import type { ISalesperson } from '@/interfaces'

export class Salesperson implements ISalesperson {
	id: number
	active: string
	name: string
	email: string
	employeeID: number
	firstName: string
	lastName: string
	jobTitle: string
	employeeActive: boolean
	branch: string
	department: string

	constructor({
		id,
		active,
		name,
		email,
		employeeID,
		firstName,
		lastName,
		jobTitle,
		employeeActive,
		branch,
		department
	}: ISalesperson) {
		this.id = id
		this.active = active
		this.name = name
		this.email = email
		this.employeeID = employeeID
		this.firstName = firstName
		this.lastName = lastName
		this.jobTitle = jobTitle
		this.employeeActive = employeeActive
		this.branch = branch
		this.department = department
	}
	public get fullName(): string {
		return this.firstName + ' ' + this.lastName
	}
}
